import { getConfig, klinikenApi } from "@/api";
import { openDialog } from "@/utils";

export type StudieKvalitetsregister = {
    id: number;
    namn: string;
};

export const convertStudieKvalitetsregisterData = ({
    studieKvalitetsregister,
}: {
    studieKvalitetsregister: StudieKvalitetsregister;
}) => {
    if (!studieKvalitetsregister) {
        return null;
    }

    return {
        value: studieKvalitetsregister.id,
        label: studieKvalitetsregister.namn,
    };
};

export const fetchStudieKvalitetsregister = async () => {
    try {
        const response = await klinikenApi.get("/operation/studie_kvalitetsregister/", getConfig());
        return response.data.results.map((item: StudieKvalitetsregister) => ({
            label: item.namn,
            value: item.id,
        }));
    } catch (error) {
        console.error(error);
        openDialog("Kunde inte hämta studie/kvalitetsregister.", "warning");
    }
};
